import { Text, TextProps } from '@/components/common/Typography';
import chroma from 'chroma-js';
import { FC } from 'react';
import { hoverStyleProps } from '../common/styleHelpers';

interface GoalStatementLinkTextProps extends TextProps {
    text: string;
    onClick: VoidFunction;
    color: string;
    isReadOnly?: boolean;
}

const GoalStatementLinkText: FC<GoalStatementLinkTextProps> = ({
    text,
    onClick,
    color,
    isReadOnly,
    ...props
}) => {
    if (isReadOnly) return <>{text}</>;

    return (
        <Text
            fontSize="inherit"
            fontWeight="inherit"
            color={color}
            whiteSpace="nowrap"
            pb={0.5}
            {...hoverStyleProps({
                color: chroma(color).brighten().hex(),
            })}
            {...props}
            onClick={onClick}
        >
            {text}
        </Text>
    );
};

export default GoalStatementLinkText;
